import axios from "axios";

const API_INSTANCE = axios.create();

export default API_INSTANCE;